<script>
import { useAlert, useTrack } from 'dashboard/composables';
import { INBOX_EVENTS } from 'dashboard/helper/AnalyticsHelper/events';

import NextButton from 'dashboard/components-next/button/Button.vue';
import InboxOptionMenu from './InboxOptionMenu.vue';

export default {
  components: {
    NextButton,
    InboxOptionMenu,
  },
  props: {
    isContextMenuOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['redirect'],
  data() {
    return {
      showInboxOptionMenu: false,
    };
  },
  watch: {
    isContextMenuOpen: {
      handler(val) {
        if (val) {
          this.showInboxOptionMenu = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    markAllRead() {
      useTrack(INBOX_EVENTS.MARK_ALL_NOTIFICATIONS_AS_READ);
      this.$store.dispatch('notifications/readAll').then(() => {
        useAlert(this.$t('INBOX.ALERTS.MARK_ALL_READ'));
      });
    },
    deleteAll() {
      this.$store.dispatch('notifications/deleteAll').then(() => {
        useAlert(this.$t('INBOX.ALERTS.DELETE_ALL'));
      });
    },
    deleteAllRead() {
      this.$store.dispatch('notifications/deleteAllRead').then(() => {
        useAlert(this.$t('INBOX.ALERTS.DELETE_ALL_READ'));
      });
    },
    openInboxOptionsMenu() {
      this.showInboxOptionMenu = !this.showInboxOptionMenu;
    },
    onInboxOptionMenuClick(key) {
      const actions = {
        mark_all_read: () => this.markAllRead(),
        delete_all: () => this.deleteAll(),
        delete_all_read: () => this.deleteAllRead(),
      };
      const action = actions[key];
      if (action) action();
      this.$emit('redirect');
    },
  },
};
</script>

<template>
  <div
    class="acl-inbox-view-conversation-header acl-inbox-list-header relative z-50 flex items-center justify-between w-full gap-1 h-[4rem] ltr:pl-4 rtl:pr-4 ltr:pr-3 rtl:pl-3"
  >
    <div class="flex items-center gap-2 min-w-0 flex-1">
      <h1 class="acl-inbox-list-title truncate min-w-0">
        {{ $t('INBOX.LIST.TITLE') }}
      </h1>
    </div>
    <div class="acl-mobile-account-menu-host relative flex items-center gap-1">
      <NextButton
        class="acl-inbox-list-menu-button"
        icon="i-lucide-ellipsis-vertical"
        slate
        md
        :variant="showInboxOptionMenu ? 'faded' : 'ghost'"
        @click="openInboxOptionsMenu"
      />
      <InboxOptionMenu
        v-if="showInboxOptionMenu"
        v-on-clickaway="openInboxOptionsMenu"
        class="absolute top-full z-50 mt-1 ltr:right-0 rtl:left-0"
        @option-click="onInboxOptionMenuClick"
      />
    </div>
  </div>
</template>

<style scoped>
.acl-inbox-view-conversation-header {
  position: relative;
  z-index: 30;
  min-height: 64px;
  height: 64px;
  align-items: center;
  padding-block-start: 1.125rem;
  padding-block-end: 1rem;
  padding-inline-start: 20px;
  padding-inline-end: 20px;
  background: #fff;
  border-bottom: 0 !important;
  backdrop-filter: blur(16px);
}

.acl-inbox-list-title {
  margin: 0;
  color: #0a0a0a;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
}

.acl-inbox-list-menu-button {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  border-radius: 50% !important;
  background: transparent !important;
  color: #0a0a0a !important;
}

.acl-inbox-list-menu-button:hover {
  background: rgba(10, 10, 10, 0.06) !important;
}

.acl-inbox-list-menu-button :deep([class*='i-lucide']) {
  width: 24px;
  height: 24px;
  background-color: currentColor;
}

:deep(.dark) .acl-inbox-list-title {
  color: #e5e5e5;
}

:deep(.dark) .acl-inbox-view-conversation-header {
  background: linear-gradient(
    180deg,
    rgba(15, 23, 42, 0.95) 0%,
    rgba(15, 23, 42, 0.82) 62%,
    rgba(15, 23, 42, 0) 100%
  );
  border-bottom: 0 !important;
}

:deep(.dark) .acl-inbox-list-menu-button {
  color: #e5e5e5 !important;
}

:deep(.dark) .acl-inbox-list-menu-button:hover {
  background: rgba(229, 229, 229, 0.08) !important;
}

@media (max-width: 767px) {
  .acl-inbox-view-conversation-header {
    padding-inline: 12px;
  }

  .acl-inbox-list-title {
    font-size: 18px;
    font-weight: 700;
    line-height: 1.15;
  }

  .acl-inbox-list-menu-button {
    width: 44px;
    height: 44px;
  }

  .acl-inbox-list-menu-button :deep([class*='i-lucide']) {
    width: 28px;
    height: 28px;
  }
}
</style>
